import React from 'react';
import {
  shape,
  string,
  bool,
  number,
  arrayOf
} from 'prop-types';
import {
  formatDate,
  formatInventory,
  showTodayOrTomorrow,
  showDateOrDateRange
} from '../../../helper/utils';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';

const DefaultBoSS = ({ fulfillment, backordered }) => {
  const bossLocation = (fulfillment?.locations || []).find((location) => location.type === 'online');
  const quantity = bossLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);
  const startDate = fulfillment?.deliveryDates?.startDate;
  const endDate = fulfillment?.deliveryDates?.endDate;
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  const deliveryEndDate = fulfillment?.deliveryDates?.endDate;
  const deliveryTimeline = fulfillment?.deliveryTimeline;
  return (
    <div className="fulfillment-tile">
      <TileHead title="Ship to Store" />
      <div className="fulfillment__sub-title">
        {(startDate || endDate) && (
          formattedStartDate === formattedEndDate ? (
            <span className="u__bold">
              {showTodayOrTomorrow(deliveryEndDate, true, deliveryTimeline, formattedEndDate)}
            </span>
          ) : (
            <span className="u__bold">
              {showDateOrDateRange({ formattedStartDate, formattedEndDate })}
            </span>
          )
        )}
        {backordered ? (
          <div className="fulfillment-qty-row">Backordered</div>
        ) : (!fulfillment.isBlindsItem
          && (
            <div className="fulfillment-qty-row">
              <span className="u__text--success">{formattedInventoryQty}</span> available
            </div>
          )
        )}
      </div>
      <TileFooter className="u__bold">
        <span className="u__text--success">FREE</span>
      </TileFooter>
    </div>
  );
};

DefaultBoSS.propTypes = {
  backordered: bool,
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }).isRequired
};

DefaultBoSS.defaultProps = {
  backordered: false,
};

export { DefaultBoSS };
